import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.treatment-planner-cta' ).each( function( key, val ) {
        const floatingItem1 = $( val ).find( '.treatment-planner-cta__floating-item' )[0];
        const floatingItem2 = $( val ).find( '.treatment-planner-cta__floating-item' )[1];
        const floatingItem3 = $( val ).find( '.treatment-planner-cta__floating-item' )[2];
        const floatingItem4 = $( val ).find( '.treatment-planner-cta__floating-item' )[3];

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: $( val ).find( '.image-wrapper' ),
            start: 'top 100%',
            end: 'bottom 15%',
            scrub: 1,
          },
        } );

        tl.to( floatingItem1, {y: '0%', ease: 'linear'}, 0 );
        tl.to( floatingItem2, {y: '0%', ease: 'linear'}, 0 );
        tl.to( floatingItem3, {y: '0%', ease: 'linear'}, 0 );
        tl.to( floatingItem4, {y: '0%', ease: 'linear'}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'treatment-planner-cta', COMPONENT );
} )( app );
